import Spinner from './Spinner'
import './LoadingPane.css'

/**
 * A centered spinner + label that fills its container. Use this where the app does not yet know WHICH
 * screen to render — a gate waiting on an entitlement, say (see RequireCredits) — so it can't paint one
 * screen and then swap it for another. For data loading WITHIN a screen that's already the right one,
 * prefer that page's own skeletons instead, which keep its layout stable.
 */
export default function LoadingPane({
  label,
  'data-testid': dataTestId,
}: {
  label: string
  'data-testid'?: string
}) {
  return (
    <div className="loading-pane" role="status" aria-live="polite" data-testid={dataTestId}>
      <Spinner size={22} />
      {label}
    </div>
  )
}
